export default __webpack_public_path__ + "2cf1dba86f4c3a7dd64f0a2c281f35db.svg";